import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ProgressSpinner } from 'primereact/progressspinner';
import { previewInterest } from './interestApi';

export default function PreviewDialog({ visible, onHide, quarterEndDate }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!visible || !quarterEndDate) return;
    setLoading(true);
    previewInterest(quarterEndDate)
      .then(setRows)
      .catch(() => setRows([]))
      .finally(() => setLoading(false));
  }, [visible, quarterEndDate]);

  const total = rows.reduce((s, r) => s + Number(r.interest || 0), 0);

  return (
    <Dialog header={`Preview — ${quarterEndDate}`} visible={visible}
            onHide={onHide} style={{ width: '900px' }} modal maximizable>
      {loading ? (
        <div className="flex justify-content-center p-5"><ProgressSpinner /></div>
      ) : (
        <>
          <div className="mb-3">
            <strong>{rows.length}</strong> accounts · Total interest{' '}
            <strong>₹{total.toFixed(2)}</strong>
          </div>
          <DataTable value={rows} paginator rows={10} size="small" stripedRows
                     emptyMessage="No eligible accounts.">
            <Column field="accountNumber"  header="Account"  sortable />
            <Column field="accountHolder"  header="Holder"   sortable />
            <Column field="runningBalance" header="Balance"  sortable
                    body={r => `₹${Number(r.runningBalance).toFixed(2)}`}
                    style={{ textAlign: 'right' }} />
            <Column field="interest"       header="Interest" sortable
                    body={r => `₹${Number(r.interest).toFixed(2)}`}
                    style={{ textAlign: 'right' }} />
          </DataTable>
        </>
      )}
    </Dialog>
  );
}